import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Label } from '@hivebrite/design-system/Label';

import AddCoverPictureV2 from 'hb-react/frontoffice/apps/Forum/components/AddCoverPictureV2';
import SelectCategories from 'hb-react/frontoffice/apps/Forum/components/SelectCategories';
import type { QuillEditorV3Ref } from 'hb-react/shared/components/DesignSystem/QuillEditor/types';
import { Text } from 'hb-react/shared/components/formik/components/inputs';
import QuillEditorWrappedV3 from 'hb-react/shared/components/QuillEditorWrappedV3';
import { fileSizeSI } from 'hb-react/shared/utils/files/fileSize';

interface CreateEditInputsProps {
  coverPictureUrl?: string | null;
  quillEditorRef: React.MutableRefObject<QuillEditorV3Ref | null>;
}

const CreateEditInputs = ({
  coverPictureUrl,
  quillEditorRef,
}: CreateEditInputsProps) => {
  const quillProps = {
    ariaDescribedBy: 'content',
    id: 'content',
    acceptAllFiles: true,
    isRequired: true,
    maxUploadSize: fileSizeSI.GB,
    maxAttachmentSize: fileSizeSI.GB,
    minHeight: 250,
    name: 'content',
    options: {
      embedLy: false,
      toolbar: {
        images: false,
        attachments: true,
        links: true,
        bold: true,
        italic: true,
        underline: true,
        inlineImage: true,
        list_ordered: true,
        list_bullet: true,
        inlineVideo: true,
        emojiPicker: false,
        mentions: false,
      },
      tooltips: {
        inlineImage: s__(
          'QuillEditor|Insert Image - The maximum size you can upload is 1 GB per file.',
        ),
        images: s__(
          'QuillEditor|Insert Image - The maximum size you can upload is 1 GB per file.',
        ),
        inlineVideo: s__('QuillEditor|Insert Video link'),
        attachments: s__(
          'QuillEditor|Insert File - The maximum size you can upload is 1 GB per file.',
        ),
        links: s__('QuillEditor|Insert link'),
      },
      toolbarFloats: [
        {
          key: 'link',
          items: [
            {
              type: 'link',
              label: __('Add Link'),
            },
          ],
        },
      ],
    },
    placeholder: __('Write your content here...'),
  };

  return (
    <WrapperInput>
      <Text
        name="title"
        label={s__('Forum|Subject')}
        placeholder={s__('Forum|Type in title here')}
        validate={{
          required: true,
          maxLength: 255,
        }}
      />
      <AddCoverPictureV2
        name="cover_picture"
        initialPreview={coverPictureUrl}
      />

      <SelectCategories />
      <Label id="content" required>
        {s__('Forum|Include Description')}
      </Label>
      <QuillEditorWrappedV3 {...quillProps} ref={quillEditorRef} />
    </WrapperInput>
  );
};

export default CreateEditInputs;

const WrapperInput = styled(Box).attrs({
  flexDirection: 'column',
  mt: 3,
})``;
